import App from 'components/app';
import {Home} from 'components/home';

import {
  Login,
  Register,
  Signin,
  SigninWithTicket,
  ForgotPassword,
  AllCategories,
  CategoryDetailPage,
  BusinessPage,
  ThankPage,
  RestorePasswordPage,
  ContactPage,
  RegisterBusiness,
  FAQPage,
  MyBusinessPaymentsPage,
  PageNotFound,
  CMSPage,
  FeedbackPage,
  FairDashBoardPage,
  DetailDemandPage,
  MyBusinessStatsPage,
  SearchProductPage
} from "pages";

import {ListDemandPage} from 'pages/demand';


import {ProductDetailPage} from 'pages/product-detail';
import {ListProductPage} from 'pages/list-product';

import {
  NewsCategoryPage,
  NewsDetailPage
} from 'pages/news';

import {
  NeedOfferDetailPage,
  MybusinessNeedOfferDetailPage,
  MybusinessNeedOfferPage
} from 'pages/need-offer';

import {
  MyBusinessEditProductPage,
  MyBusinessPage,
  MyBusinessAddProductPage,
  MyBusinessAddFairProductPage,
  MyBusinessListFairProductPage,
  MyBusinessFairPage,
  MyBusinessAnnouncementPage,
  MyBusinessAnnouncementDetailPage,
  MyBusinessManageOrderPage,
  MyBusinessManageOrderDetailPage,
  MyBusinessPostDemandPage,
  MyBusinessProfilePage
} from 'pages/my-business';

import SubCategories from 'pages/sub-categories/SubCategories.jsx';

import {
  Profile,
  ChangePassword,
  Complaint,
  ComplaintDetail,
  Dashboard,
  Announcement,
  SendComplaint,
  SendNeedoffer,
  FavoriteProduct,
  MyDemand,
  PostDemandPage,
  MyRequests,
  RequestDetail,
  MyShoppingCartPage,
  AnnouncementDetail,
  MyDemandDetailPage,
  OrderHistory,
  OrderHistoryDetail
} from "pages/users";

import {MyBusinessRequestsPage, MyBusinessRequestDetailPage, MyBusinessManageProductPage} from 'pages/my-business';

import {ListBusinesses, AddBusiness, EditBusiness, BusinessPageWithSlug, PhuyenBusinessPage} from 'pages/businesses';

const routes = [
  {
    component: App,
    routes: [
      /* I. FRONT OFFICE */
      {path: '/', exact: true, component: Home},
      {path: '/signin', exact: true, component: Signin},
      {path: '/signinWithTicket/:id', exact: true, component: SigninWithTicket},
      {path: '/signup', exact: true, component: Register},
      {path: '/forgot-password', exact: true, component: ForgotPassword},
      {path: '/register-business', exact: true, component: RegisterBusiness}, // Dang ky doanh nghiep
      {path: '/post-product', exact: true, component: Home}, // Dang san pham
      {path: '/post-demand', exact: true, component: Home}, // Dang san pham
      {path: '/search', exact: true, component: SearchProductPage},

      {path: '/demands', exact: true, component: ListDemandPage}, // Danh sach nhu cau
      {path: '/demands/:id', exact: true, component: DetailDemandPage}, // Danh sach nhu cau

      /* I.1 Categories */
      {path: '/all-categories', exact: true, component: AllCategories},
      {path: '/category/:id', exact: true, component: SubCategories},
      //{ path: '/sub-category/:id', exact: true, component: CategoryDetailPage },
      {path: '/list-products/:catID', exact: true, component: ListProductPage},
      {path: '/nhom-san-pham/:slug/:catID', exact: true, component: ListProductPage},

      /* I.2 Products */
      {path: '/product/:id', exact: true, component: ProductDetailPage},
      {path: '/san-pham/:slug/:id', exact: true, component: ProductDetailPage},
      {path: '/search', exact: true, component: Home},

      /* I.3 News */
      {path: '/news-category/:id', exact: true, component: NewsCategoryPage},
      {path: '/news/:id', exact: true, component: NewsDetailPage},
      {path: '/tin-tuc/:slug/:id', exact: true, component: NewsDetailPage},

      /* I.4 Misc */
      {path: '/faq', exact: true, component: FAQPage},
      {path: '/terms', exact: true, component: Home},
      {path: '/privacy', exact: true, component: Home},
      {path: '/contact', exact: true, component: ContactPage},
      {path: '/feedback', exact: true, component: FeedbackPage},

      /* I.5 Business */
      {path: '/business/:id', exact: true, component: BusinessPage},
      {path: '/doanh-nghiep/:slug', exact: true, component: BusinessPageWithSlug},
      {path: '/business/:id/product/:productID', exact: true, component: Home},//thieu

      /* II. USER SECTION */
      {path: "/dashboard", exact: true, component: Dashboard},
      {path: "/user/needoffer", exact: true, component: SendNeedoffer},
      {path: "/user/announcements", exact: true, component: Announcement},
      {path: "/user/announcements/:id", exact: true, component: AnnouncementDetail},
      {path: "/profile", exact: true, component: Profile},
      {path: "/user/change-pass", exact: true, component: ChangePassword},
      {path: "/user/complains", exact: true, component: Complaint},
      {path: "/user/complains/post", exact: true, component: SendComplaint},
      {path: "/user/complains/:id", exact: true, component: ComplaintDetail},
      {path: "/user/favorites", exact: true, component: FavoriteProduct},
      {path: "/user/my-posted-demands", exact: true, component: MyDemand}, // Nhu cầu đã đăng
      {path: "/user/my-posted-demands/:id", exact: true, component: MyDemandDetailPage},
      {path: "/user/post-demand", exact: true, component: PostDemandPage}, // Gửi nhu cầu
      {path: "/user/my-requests", exact: true, component: MyRequests}, // Yêu cầu đã gửi
      {path: "/user/my-requests/:id", exact: true, component: RequestDetail}, // Yêu cầu đã gửi
      {path: "/user/my-shopping-cart", exact: true, component: MyShoppingCartPage}, // Giỏ hàng của tôi
      {path: "/user/order-history", exact: true, component: OrderHistory}, // Lịch sử giao dịch
      {path: "/user/order-history/:id", exact: true, component: OrderHistoryDetail}, // Lịch sử giao dịch
      {path: "/phuyen-businesses", exact: true, component: PhuyenBusinessPage}, // Lịch sử giao dịch

      /* III. BUSINESS SECTION */
      {path: "/my-businesses", exact: true, component: MyBusinessPage},
      {path: "/my-business/dashboard", exact: true, component: MyBusinessPage},
      {path: "/my-business/announcements", exact: true, component: MyBusinessAnnouncementPage},
      {path: "/my-business/announcements/:id", exact: true, component: MyBusinessAnnouncementDetailPage},
      {path: "/my-business/payments", exact: true, component: MyBusinessPaymentsPage},
      {path: "/my-business/payments/edit/:id", exact: true, component: MyBusinessPaymentsPage},
      {path: "/my-business/edit", exact: true, component: MyBusinessProfilePage}, // Sua thong tin doanh nghiep
      {path: "/my-business/post-product", exact: true, component: MyBusinessAddProductPage}, // Dang san pham
      {path: "/my-business/post-fair-product", exact: true, component: MyBusinessAddFairProductPage}, // Dang san pham
      {path: "/my-business/products", exact: true, component: MyBusinessManageProductPage}, // Liet ke danh sach san pham
      {path: "/my-business/edit-product/:id", exact: true, component: MyBusinessEditProductPage}, // Liet ke danh sach san pham
      {path: "/my-business/edit-fair-product/:id", exact: true, component: MyBusinessEditProductPage}, // Liet ke danh sach san pham
      {path: "/my-business/list-fair-product", exact: true, component: MyBusinessListFairProductPage}, // Liet ke danh sach san pham
      {path: "/my-business/stats", exact: true, component: MyBusinessStatsPage}, // Liet ke danh sach san pham
      {path: "/my-business/orders", exact: true, component: MyBusinessManageOrderPage}, // Liet ke danh sach san pham
      {path: "/my-business/requests", exact: true, component: MyBusinessRequestsPage}, // Liet ke danh sach san pham
      {path: "/my-business/requests/:id", exact: true, component: MyBusinessRequestDetailPage}, // Liet ke danh sach san pham
      {path: "/my-business/orders/:id", exact: true, component: MyBusinessManageOrderDetailPage}, // Lịch sử giao dịch
      {path: "/my-business/demands", exact: true, component: MybusinessNeedOfferPage}, // Danh sach nhu cau da dang
      {path: "/my-business/demand/:id", exact: true, component: MybusinessNeedOfferDetailPage}, // chi tiet nhu cau da dang
      {path: "/my-business/need-offer/:id", exact: true, component: NeedOfferDetailPage}, // Chi tiet hoi thoai nhu cau da dang
      {path: "/my-business/post-demand", exact: true, component: MyBusinessPostDemandPage}, // Chi tiet hoi thoai nhu cau da dang
      {path: "/my-business/fair", exact: true, component: MyBusinessFairPage}, // Liet ke danh sach san pham

      {path: "/thank-you", exact: true, component: ThankPage}, // Cam on

      {path: "/restore-password", exact: true, component: RestorePasswordPage}, // Cam on

      {path: "/cms/:slug", exact: true, component: CMSPage}, // Cam on

      {path: "/fair", exact: true, component: FairDashBoardPage}, // 404

      {path: "*", exact: true, component: PageNotFound} // 404


    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./routes/routes.js